import {createStore} from "vuex";
import router from "@/router";
import http from "@/http";

const envToken = process.env.VUE_APP_TOKEN
const envUserName = process.env.VUE_APP_USER_NAME

const store = createStore({
    state: {
        route: null,
        loading: false,
        token: localStorage.getItem('token'),
        pToken: localStorage.getItem('ptoken'),
        userName: localStorage.getItem('userName'),
        calculatorType: 'funding',
        calculator: {
            car_cost: 100000,
            car_age: 'new',
            car_year: 2021,
            car_type: 'private',
            imprest: 0,
            payments: 60,
            bullet_loan_amount: 0
        },
        otpKey: null,
        interests: null,
        agencies: null,
        agency: null,
        agencyId: null,
        cta: {
            text: null,
            url: null,
            target: '_blank'
        },
        mustLogin: false,
        hideYear: false,
        hideType: false,
        hideAge: false,
        defaultYear: 2022,
        defaultCarType: 'private',
        carType: 'private',
        onlyCarType: false,
        defaultAge: 'new',
        defaultPresets: 'popular',
        titleText: null,
        bulletLoanLabel: null,
        defaultBulletLoan: 0,
        monthsLabel: null,
        imprestLabel: null,
        defaultImprest: null,
        monthlyPaymentLabel: null,
        fees: {},
        showOnlyResults: false,
        leasingCalculatorEnabled: false,
        lightTheme: false,
        cars: [],
        currentCarId: null,
        carPage: 1,
        carPages: 0,
        imageUrl: null
    },
    getters: {
        token({token}){
            if(token){
                return token
            }
            if(envToken){
                return envToken
            }
            return null
        },
        calculatorType({calculatorType}){
            return calculatorType
        },
        calculator({calculator}){
            return calculator
        },
        pToken({pToken}){
            return pToken
        },
        userName({userName}){
            if(userName){
                return userName
            }
            if(envUserName){
                return envUserName
            }
            return null;
        },
        otpKey({otpKey}){
            return otpKey
        },
        interests({interests}){
            return interests
        },
        agencies({agencies}){
            return agencies
        },
        fees({fees}){
            return fees
        },
        agency({agency}){
            return agency
        },
        agencyId({agencyId, agency}){
            if(agencyId){
                return agencyId
            }
            if(agency && agency.id){
                return agency.id
            }
            return null;
        },
        cta({cta}){
            return cta
        },
        mustLogin({mustLogin}){
            return mustLogin
        },
        hideYear({hideYear}){
            return hideYear
        },
        hideType({hideType}){
            return hideType
        },
        hideAge({hideAge}){
            return hideAge
        },
        defaultYear({defaultYear}){
            return defaultYear
        },
        defaultAge({defaultAge}){
            return defaultAge
        },
        defaultPresets({defaultPresets}){
            return defaultPresets
        },
        titleText({titleText}){
            return titleText
        },
        bulletLoanLabel({bulletLoanLabel}){
            return bulletLoanLabel
        },
        monthsLabel({monthsLabel}){
            return monthsLabel
        },
        imprestLabel({imprestLabel}){
            return imprestLabel
        },
        monthlyPaymentLabel({monthlyPaymentLabel}){
            return monthlyPaymentLabel
        },
        defaultCarType({defaultCarType}){
            return defaultCarType
        },
        carType({carType}){
            return carType
        },
        onlyCarType({onlyCarType}){
            return onlyCarType
        },
        showOnlyResults({showOnlyResults}){
            return showOnlyResults
        },
        defaultBulletLoan({defaultBulletLoan}){
            return defaultBulletLoan
        },
        defaultImprest({defaultImprest}){
            return defaultImprest
        },
        leasingCalculatorEnabled({leasingCalculatorEnabled}){
            return leasingCalculatorEnabled
        },
        lightTheme({lightTheme}){
            return lightTheme
        },
        cars({cars}){
            return cars
        },
        currentCarId({currentCarId}){
            return currentCarId
        },
        currentCar({cars, currentCarId}){
            if(cars && cars.length > 0){
                return cars.find(car => car.id === currentCarId);
            }
            return null;
        },
        carPage({carPage}){
            return carPage
        },
        carPages({carPages}){
            return carPages
        },
        route({route}){
            return route
        },
        loading({loading}){
            return loading
        },
        agentAreaEnabled({agency}){
            return agency && agency.car_activity_active && ['calc2.pama.co.il','pama.nnd.co.il','calc.pama.co.il','localhost:8080'].includes(window.location.host)
        },
        imageUrl({imageUrl}){
            return imageUrl
        }
    },
    mutations: {
        token(state, token) {
            state.token = token
            if(token){
                localStorage.setItem('token', token)
            }else{
                localStorage.removeItem('token')
            }
        },
        calculatorType(state, calculatorType) {
            state.calculatorType = calculatorType
        },
        calculator(state, calculator) {
            state.calculator = calculator
        },
        pToken(state, token) {
            state.ptoken = token
            if(token){
                localStorage.setItem('ptoken', token)
            }else{
                localStorage.removeItem('ptoken')
            }
        },
        userName(state, userName) {
            state.userName = userName
            if(userName){
                localStorage.setItem('userName', userName)
            }else{
                localStorage.removeItem('userName')
            }
        },
        otpKey(state, otpKey) {
            state.otpKey = otpKey
        },
        interests (state, interests) {
            state.interests = interests
        },
        agencies (state, agencies) {
            state.agencies = agencies
        },
        fees (state, fees) {
            state.fees = fees
        },
        agency (state, agency) {
            state.agency = agency
        },
        agencyId (state, agencyId) {
            state.agencyId = agencyId
        },
        cta (state, cta) {
            state.cta = cta
        },
        mustLogin (state, mustLogin) {
            state.mustLogin = mustLogin
        },
        hideYear(state, hideYear) {
            state.hideYear = hideYear
        },
        hideType(state, hideType) {
            state.hideType = hideType
        },
        hideAge(state, hideAge) {
            state.hideAge = hideAge
        },
        defaultYear(state, defaultYear) {
            state.defaultYear = defaultYear
        },
        defaultAge(state, defaultAge) {
            state.defaultAge = defaultAge
        },
        defaultPresets(state, defaultPresets) {
            state.defaultPresets = defaultPresets
        },
        titleText(state, titleText) {
            state.titleText = titleText
        },
        bulletLoanLabel(state, bulletLoanLabel) {
            state.bulletLoanLabel = bulletLoanLabel
        },
        monthsLabel(state, monthsLabel) {
            state.monthsLabel = monthsLabel
        },
        imprestLabel(state, imprestLabel) {
            state.imprestLabel = imprestLabel
        },
        monthlyPaymentLabel(state, monthlyPaymentLabel) {
            state.monthlyPaymentLabel = monthlyPaymentLabel
        },
        carType(state, carType) {
            state.carType = carType
        },
        onlyCarType(state, onlyCarType) {
            state.onlyCarType = onlyCarType
        },
        carCost(state, cost){
            if(typeof(cost) === 'string'){
                state.calculator.car_cost = parseInt(cost, 10)
            }else{
                state.calculator.car_cost = cost
            }
        },
        defaultBulletLoan(state, defaultBulletLoan){
            if(typeof(defaultBulletLoan) === 'string'){
                state.defaultBulletLoan = parseInt(defaultBulletLoan, 10)
            }else{
                state.defaultBulletLoan = defaultBulletLoan
            }
        },
        defaultImprest(state, defaultImprest){
            if(typeof(defaultImprest) === 'string'){
                state.defaultImprest = parseInt(defaultImprest, 10)
            }else{
                state.defaultImprest = defaultImprest
            }
        },
        showOnlyResults(state, showOnlyResults){
            state.showOnlyResults = showOnlyResults
        },
        leasingCalculatorEnabled(state, leasingCalculatorEnabled){
            state.leasingCalculatorEnabled = leasingCalculatorEnabled
        },
        lightTheme(state, lightTheme){
            state.lightTheme = lightTheme
        },
        cars(state, cars){
            state.cars = cars
        },
        currentCarId(state, currentCarId){
            state.currentCarId = currentCarId
        },
        currentCar(state, currentCar){
            if(currentCar && currentCar.id){
                state.currentCarId = currentCar.id
            }
        },
        carPage(state, carPage){
            state.carPage = carPage
        },
        carPages(state, carPages){
            state.carPages = carPages
        },
        route(state, route){
            state.route = route
        },
        loading(state, loading){
            state.loading = loading
        },
        imageUrl(state, url){
            state.imageUrl = url
        }
    },
    actions: {
        loading({commit}, loading){
            commit('loading', loading)
            if (loading) {
                setTimeout(() => {
                    commit('loading', false)
                }, 10000);
            }
        },
        async otp({commit}, credentials){
            const {status, data} = await http.post('otp', credentials)
            if(status === 200 && data.key){
                commit('otpKey', data.key)
                return true
            }
            return false
        },
        async otpConfirmation({commit, getters, dispatch}, credentials){
            credentials.key = getters.otpKey
            const {data} = await http.post('otp-confirmation', credentials)
            if(data.token){
                commit('token', data.token)
                if(data.p_token){
                    commit('pToken', data.p_token)
                }
                dispatch('reportEvent', {user_id: data.token}, 'PageView')
                if(data.name){
                    commit('userName', data.name)
                }
                dispatch('loadAgencies')
                return true
            }
            return false
        },
        async loadInterests({commit, getters, dispatch}){
            const path = []
            const params = {car_type: getters.carType};
            if(getters.agencyId){
                path.push('agency')
                path.push(getters.agencyId)
            }else{
                path.push('interests')
                if(getters.agency && getters.agency.id){
                    params.agency = getters.agency.id
                }
            }

            const {data} = await http.get(path.join('/'), {params})
            if(data){
                if(data.interests){
                    commit('interests', data.interests)
                }

                if(data.agency){
                    commit('agency', data.agency)
                    if(data.agency.car_activity_active){
                        dispatch('loadCars')
                    }else{
                        dispatch('unloadCars')
                    }
                }
            }
        },
        async loadAgencies({commit}){
            const {data} = await http.get('agencies')
            if(data && data.agencies){
                commit('agencies', data.agencies)
            }
        },
        async loadFees({commit}){
            const {data} = await http.get('fees')
            if(data && data.fees){
                commit('fees', data.fees)
            }
        },
        async logout({commit, dispatch}){
            commit('token', null)
            commit('userName', null)
            dispatch('loadInterests')
            await router.replace('/login')
        },
        async reportEvent({getters}, data){
            const type = data.action || "PageView"
            const user_id = getters.pToken
            if(typeof(window.gtag) === 'function'){
                const eventData = {
                    user_id,
                    event_category: 'calc_usage',
                    ...data
                }
                window.gtag('event', type, eventData)
            }
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: type,
                user_id,
                event_category: 'calc_usage',
                ...data
            });
            console.log('event', {type, user_id, ...data})
            await http.post('report-event', {type, user_id, ...data})
        },
        async loadCars({commit, getters}){
            const {data} = await http.get('cars', {
                params: {
                    page: getters.carPage,
                    agency_id: getters.agencyId,
                    amount: 15
                }
            })
            if(data && data.cars){
                if(data.cars.data){
                    commit('cars', data.cars.data)
                }
                if(data.cars.current_page){
                    commit('carPage', data.cars.current_page)
                }
                if(data.cars.last_page){
                    commit('carPages', data.cars.last_page)
                }
            }
        },
        async unloadCars({commit, getters}){
            commit('cars', [])
            commit('currentCarId', null)
            commit('carPage', 1)
            commit('carPages', 0)
            if(getters.route && getters.route.path.startsWith('/agents-area')){
                await router.replace({
                    name: 'home'
                })
            }
        },
        async locateCar({getters, dispatch, commit}, plate_number){
            const additionalData = {
                agency_id: getters.agencyId
                    //|| 'fa246d0262c3925617b0c72bb20eeb1d'
            }
            const {data} = await http.get('cars/locate', {params: {plate_number, ...additionalData}})
            if(data && data.car){
                dispatch('pushCar', data.car)
                commit('currentCarId', data.car.id)
                return data.car;
            }
            return null
        },
        pushCar({getters, commit}, car){
            const cars = getters.cars;
            const carIndex = getters.cars.findIndex(c => c.id === car.id)
            if(carIndex === -1){
                cars.push(car)
            }else{
                cars[carIndex] = car
            }
            commit('cars', cars)
        },
        removeCar({getters, commit}, car){
            const cars = getters.cars;
            const carIndex = getters.cars.findIndex(c => c.id === car.id)
            if(carIndex !== -1){
                cars.splice(carIndex, 1)
            }
            commit('cars', cars)
        },
        async saveCar({getters, dispatch}, car){
            const additionalData = {
                agency_id: getters.agencyId
                    //|| '\'
            }
            dispatch('pushCar', car)
            await http.post(`cars/${car.id}`, {...car, ...additionalData})
        },
        async deleteCar({dispatch}, car){
            if(confirm('בטוח שברצונך למחוק רכב זה?')){
                dispatch('removeCar', car)
                await http.delete(`cars/${car.id}`)
                return true;
            }
            return false;
        },
        async moveCarToTop(store, car){
            const response = await http.post(`cars/move_to_top/${car.id}`)
            return response && response.status === 200;
        },
        async saveCarImage({getters, dispatch}, {id, image}){
            const imageData = new FormData();
            imageData.append('agency_id', getters.agencyId
                //|| 'fa246d0262c3925617b0c72bb20eeb1d'
            );
            imageData.append('image', image)
            imageData.append('id', id)
            const {data} = await http.post(`cars/images`, imageData)
            if(data && data.car){
                dispatch('pushCar', data.car)
            }
        },
        async deleteCarImage({getters, dispatch}, {id, path}){
            const imageData = new FormData();
            imageData.append('agency_id', getters.agencyId
               //|| 'fa246d0262c3925617b0c72bb20eeb1d'
            );
            imageData.append('path', path)
            imageData.append('id', id)
            const {data} = await http.post(`cars/images/delete`, imageData)
            if(data && data.car){
                dispatch('pushCar', data.car)
            }
        }
    }
})

export default store
